module.exports = __webpack_public_path__ + "static/media/under_maintenance.07b073e1.png";